import type { ComponentProps } from "solid-js";
import { Show } from "solid-js";
import Text from "../../text/Text";
import { isNil } from "lodash-es";
import type { ListItemHtmlProps, TextOption } from "../../../types/Menu";
import ListItemContainer from "./ListItemContainer";
import Pill from "../../pill/Pill";

export type TextListItemProps = Omit<TextOption<null>, "variant" | "value"> & {
  htmlProps: ListItemHtmlProps | null;
  // Only used for WYSIWYG commands (such as font family and text type)
  labelClass?: string;
  labelStyle?: ComponentProps<"p">["style"];
};

const TextListItem = (props: TextListItemProps) => (
  <ListItemContainer htmlProps={props.htmlProps} disabled={props.disabled} hidden={props.hidden} type="column">
    <span class="flex items-center justify-between gap-1.5">
      <Text
        as="span"
        truncate
        text={props.label}
        class="text-primary group-disabled:text-disabled"
        classList={{
          "text-base-regular": isNil(props.description) && isNil(props.labelClass),
          "text-base-medium": !isNil(props.description) && isNil(props.labelClass),
          [`${props.labelClass}`]: !isNil(props.labelClass),
        }}
        style={props.labelStyle}
      />
      <Show when={props.pill}>{(pill) => <Pill {...pill()} />}</Show>
    </span>
    <Show when={props.description}>
      {(description) => (
        <Text
          as="span"
          truncate={2}
          text={description()}
          classList={{ "group-aria-selected:text-primary group-selected:text-primary": props.disabled !== true }}
          class="text-left text-base-regular text-secondary group-disabled:text-disabled"
        />
      )}
    </Show>
  </ListItemContainer>
);

export default TextListItem;
